import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './404.css';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="nf-wrap">
            <div className="nf-card">
                <img
                    src={process.env.PUBLIC_URL + '/logo-soroby.svg'}
                    alt="Soroby"
                    className="nf-logo"
                />
                <p className="nf-code">404</p>
                <h1 className="nf-title">{t('fourOhFour.title')}</h1>
                <p className="nf-text">
                    {t('fourOhFour.message')}
                </p>
                <div className="nf-actions">
                    <Link to="/" className="nf-btn nf-btn-primary">
                        {t('fourOhFour.goHome')}
                    </Link>
                    <button
                        type="button"
                        className="nf-btn nf-btn-ghost"
                        onClick={() => navigate(-1)}
                    >
                        {t('auth.goBack')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
